import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select } from '@ngxs/store';
import { UndoState } from 'src/app/undo/state/undo.state';
import { Observable } from 'rxjs';
import { trigger, transition, style, animate, sequence } from '@angular/animations';

@Component({
  selector: 'app-view-undo',
  templateUrl: './view-undo.component.html',
  styleUrls: ['./view-undo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('show', [ 
      transition(':enter', 
        sequence([
          style({
            transform: `translateY(-100%)`,
            opacity: 0
          }),
          animate('150ms ease-in-out', style({ 
            transform: `translateY(0%)`,
            opacity: 1
          }))
        ])
      )
      ])]
})
export class ViewUndoComponent implements OnInit {
  @Select(UndoState.canUndo)
  canUndo$: Observable<boolean>;

  @Select(UndoState.canRedo)
  canRedo$: Observable<boolean>;

  @Select(UndoState.getUndoCount)
  undoCount$: Observable<number>;

  constructor(
    private viewService: ViewService
  ) { }

  ngOnInit() {

  }

  handleUndoClick() {
    this.viewService.undo();
  }

  handleRedoClick() {
    this.viewService.redo();
  }

  handleResetClick() {
    this.viewService.resetChapter();
  }
}
